'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Left;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function Left(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-chevron-left ' + className,
      viewBox: '0 0 6 18' },
    _react2.default.createElement('path', { fill: 'currentColor', d: 'M0.130580357,8.21428571 C0.130580357,8.30133972 0.164062165,8.37834788 0.231026786,8.4453125 L4.91183036,13.1261161 C4.97879498,13.1930807 5.05580314,13.2265625 5.14285714,13.2265625 C5.22991115,13.2265625 5.30691931,13.1930807 5.37388393,13.1261161 L5.87611607,12.6238839 C5.94308069,12.5569193 5.9765625,12.4799111 5.9765625,12.3928571 C5.9765625,12.3058031 5.94308069,12.228795 5.87611607,12.1618304 L1.92857143,8.21428571 L5.87611607,4.26674107 C5.94308069,4.19977645 5.9765625,4.12276829 5.9765625,4.03571429 C5.9765625,3.94866028 5.94308069,3.87165212 5.87611607,3.8046875 L5.37388393,3.30245536 C5.30691931,3.23549074 5.22991115,3.20200893 5.14285714,3.20200893 C5.05580314,3.20200893 4.97879498,3.23549074 4.91183036,3.30245536 L0.231026786,7.98325893 C0.164062165,8.05022355 0.130580357,8.12723171 0.130580357,8.21428571 Z' })
  );
}

Left.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Chevron/Left.js
// module id = 179
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15